import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { LocationData } from "../../../models/LocationData";
import DataSvc from "../../../services/dataSvc";
import { TextFileDownload } from "../../Common/TextFileDownload";
import { TimespanPicker } from "../TimespanPicker";
import { useTimespanPicker } from "../TimespanPicker/hooks";

import "./styles.scss";

type IDownloadActivityLogsProps = {
  organizationId: string;
  locations: LocationData[];
};

export const DownloadActivityLogs: React.FC<IDownloadActivityLogsProps> = ({
  locations,
  organizationId,
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`dataDownloadPage.downloadActivityLogs.${key}`);

  const timespan = useTimespanPicker();

  const queryKey = useMemo(
    () => [
      "download-activity",
      timespan.timespan,
      locations.map((location) => location.id.toString()),
    ],
    [timespan, locations]
  );
  const queryFunction = useCallback(async () => {
    const data = await DataSvc.getFacilityDataActivityLogs({
      organizationId,
      timespan: timespan.timespan,
      locations,
    });
    return { filename: "activity-logs", content: data };
  }, [timespan, locations, organizationId]);

  return (
    <div className="white-border-panel download-activity-logs">
      <h3>{t("download_activity_logs")}</h3>
      <div className="content">
        <div className="download-activity-logs-controls">
          <TimespanPicker timespan={timespan} />
        </div>
        <TextFileDownload queryKey={queryKey} queryFunction={queryFunction} />
      </div>
    </div>
  );
};
